import createIcon from '../../createIcon';

/**
 * @component @name Rowing
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOCAxNEwzLjUgMTguNUw1IDIwTDguNSAxNi41SDEwLjVMOCAxNFpNMTQuNSAwLjVDMTMuNCAwLjUgMTIuNSAxLjQgMTIuNSAyLjVDMTIuNSAzLjYgMTMuNCA0LjUgMTQuNSA0LjVDMTUuNiA0LjUgMTYuNSAzLjYgMTYuNSAyLjVDMTYuNSAxLjQgMTUuNiAwLjUgMTQuNSAwLjVaTTIwLjUgMjAuNTFMMTcuNSAyMy41TDE0LjUxIDIwLjQ5VjE5TDcuNDEgMTEuOTFDNy4xIDExLjk2IDYuOCAxMS45OCA2LjUgMTEuOThWOS44MkM4LjE2IDkuODUgMTAuMTEgOC45NSAxMS4xNyA3Ljc4TDEyLjU3IDYuMjNDMTIuOTIgNS44NCAxMy41NiA1LjUgMTQuMjIgNS41SDE0LjI1QzE1LjQ5IDUuNTEgMTYuNSA2LjUyIDE2LjUgNy43NlYxMy41MUMxNi41IDE0LjM1IDE2LjE1IDE1LjEyIDE1LjU4IDE1LjY3TDEyIDEyLjA5VjkuODJDMTEuMzcgMTAuMzQgMTAuNTcgMTAuODQgOS43MSAxMS4yMUwxNiAxNy41SDE3LjVMMjAuNSAyMC41MVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Rowing = createIcon('Rowing', [
  [
    'path',
    {
      d: 'M8 14L3.5 18.5L5 20L8.5 16.5H10.5L8 14ZM14.5 0.5C13.4 0.5 12.5 1.4 12.5 2.5C12.5 3.6 13.4 4.5 14.5 4.5C15.6 4.5 16.5 3.6 16.5 2.5C16.5 1.4 15.6 0.5 14.5 0.5ZM20.5 20.51L17.5 23.5L14.51 20.49V19L7.41 11.91C7.1 11.96 6.8 11.98 6.5 11.98V9.82C8.16 9.85 10.11 8.95 11.17 7.78L12.57 6.23C12.92 5.84 13.56 5.5 14.22 5.5H14.25C15.49 5.51 16.5 6.52 16.5 7.76V13.51C16.5 14.35 16.15 15.12 15.58 15.67L12 12.09V9.82C11.37 10.34 10.57 10.84 9.71 11.21L16 17.5H17.5L20.5 20.51Z',
      key: 'vy2nhg',
    },
  ],
]);

export default Rowing;
